import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChanagePasswordRoutingModule } from './chanage-password-routing.module';
import { ChanagePasswordComponent } from './chanage-password.component';
import { ChangePasswordWidgetModule } from 'src/app/widgets/change-password/change-password.module';
import { DxLoadPanelModule } from 'devextreme-angular';


@NgModule({
  declarations: [ChanagePasswordComponent],
  imports: [
    CommonModule,
    ChanagePasswordRoutingModule,ChangePasswordWidgetModule,DxLoadPanelModule
  ]
}) 
export class ChangePasswordModule { }
